import OrderManager from "./OrderManager";
import SectionDispatcher from "./Section/SectionDispatcher";

export default class OrderManagerShipmentEdit extends OrderManager
{

    constructor(params)
    {
        super(params);

        this.fetchOptions()
            .then(options => this.setOptions(options))
            .then(() => this.initWidgetManager())
            .then(() => this.init())
            .catch(error => console.log(error))
    }

    init()
    {

        this.initSectionDeliveryInfo();

        BX.addCustomEvent("onAjaxSuccessFinish", (e) => {
            if (e.url.indexOf("/bitrix/admin/sale_order_ajax.php") >= 0) {
                this.initSectionDeliveryInfo();
            }
        });
    }

    initWidgetManager()
    {
        return new Promise(resolve => {
            this.widgetManager = new WidgetManager({}, this);
            this.widgetManager.init().then(() => resolve(true));
        });
    }

    initSectionDeliveryInfo()
    {

        if (!this.isProfileLpost()) {
            return false;
        }

        BX.ajax.runAction("lpost:delivery.api.OrderEditDelivery.getStorageOrderDataDelivery", {
            cache: false
        })
            .then(response => this.createSectionDeliveryInfo(response.data))
    }

    createSectionDeliveryInfo(fields)
    {
        try{
            let section = SectionDispatcher.get(
                this.getSelectedDeliveryProfile()
            );

            section.setFields(fields);

            this.blockProperty(this.options.properties);

            BX('section_map_1').innerHTML = section.getHtml();
        }
        catch (e) {
            BX('section_map_1').innerHTML = e.message;
        }

    }

    refresh()
    {
        BX.Sale.Admin.OrderShipment.prototype.getDeliveryPrice()
    }

    renderPrice(price)
    {
        BX("PRICE_DELIVERY_1").value = price;
    }

    renderAdditionalField(value, code) {
        return false;
    }

    renderAddress(value)
    {
        return false;
    }


}


